export default "<div id=\"this\">\n  <div *ngFor=\"let i of [0, 1, 2, 3, 4, 5]\" class=\"this-bar\"></div>\n</div>\n"